import { Injectable } from 'angular-ts-decorators';

/**
 * # focusManager
 * This service is storing a getter and a setter for the field that has
 * a current application-managed-focus
 */
@Injectable('focusManager')
export class FocusManager {
  /**
   *
   * Gets the value of the field with the current app-manged-focus
   * @returns {string}
   * Value of the field with app-manage-focus
   */
  public setter: (input?: any) => void;

  /**
   *
   * sets the value of the field with the current app-manged-focus
   * @returns {Void}
   * Nothing
   */
  public getter: () => void;

  constructor() {
    'ngInject';

    this.setter = undefined;
    this.getter = undefined;
  }

  /**
   *
   * Resets getter & setter to undefined
   * @param {function} getter
   * function that will be set as a getter
   * @param {function} setter
   * function that will be set as a setter
   * @returns {Void}
   * Nothing
   */
  set(getter: () => void, setter: (input?: any) => void): void {
    this.getter = getter;
    this.setter = setter;
  }

  /**
   *
   * Resets getter & setter to undefined
   * @returns {Void}
   * Nothing
   */
  reset(): void {
    this.getter = undefined;
    this.setter = undefined;
  }
}
